import type {
	HTTPValidationError,
	ProductsQueryRequestModel,
	ProductsQueryResponseModel,
} from '@/shared/generated'
import type { UseQueryOptions } from '@/shared/lib/query-client'
import type { AxiosError } from 'axios'

import { useQuery } from '@tanstack/react-query'

import { client } from '@/shared/api/client'
import { Operators } from '@/shared/components/query-builder'

export const assortmentQueries = {
	list: (params?: ProductsQueryRequestModel) => ({
		queryKey: ['assortment-list', params],
		queryFn: () => client.products.queryProducts(params || {}),
	}),
}
export function useAssortmentListQuery<T = ProductsQueryResponseModel>(
	params?: ProductsQueryRequestModel,
	options?: UseQueryOptions<
		ProductsQueryResponseModel,
		AxiosError<HTTPValidationError>,
		T
	>
) {
	return useQuery<
		ProductsQueryResponseModel,
		AxiosError<HTTPValidationError>,
		T
	>({
		...assortmentQueries.list(params),
		...(options || {}),
	})
}

export function useUnassignedProductsCountQuery(
	params?: ProductsQueryRequestModel,
	options?: UseQueryOptions<
		ProductsQueryResponseModel,
		AxiosError<HTTPValidationError>,
		number | undefined
	>
) {
	return useQuery<
		ProductsQueryResponseModel,
		AxiosError<HTTPValidationError>,
		number | undefined
	>({
		queryKey: ['unassigned-assortment-count', params],
		queryFn: () =>
			client.products.queryProducts({
				limit: 1,
				...(params || {}),
				filters: [
					{
						name: 'pricing_campaign_id',
						operation: Operators.IS_EMPTY as const,
						value: '1',
					},
					...(params?.filters || []),
				],
			}),
		...(options || {}),
		select: (data) => data.total_count,
	})
}
